import type { shell as en } from '@/i18n/locales/en/shell';
import type { Translation } from '@/i18n/types';

export const shell: Translation<typeof en> = {
  notFound: {
    title: 'Pagina niet gevonden',
    body: 'Dat adres bestaat niet.',
    backLink: 'Terug naar het overzicht',
  },
  configWarning: {
    body: '<0>Onvolledige configuratie.</0> {{missing}} ontbreekt. Zet dit in <1>.env.local</1> voor lokale ontwikkeling (zie <2>.env.example</2>), of in de container-omgeving voor een deployment.',
  },
  skipToContent: 'Naar de inhoud',
  brandName: 'NOLATR',
  mainNav: 'Hoofdmenu',
  sectionNav: 'Sectie',
  accountNav: 'Account',
  openMainMenu: 'Menu openen',
  closeMainMenu: 'Menu sluiten',
  activeCompany: 'Actief bedrijf',
  profileStub: {
    title: 'Profiel',
    lead: 'Je profielpagina komt eraan — voorlopig is dit een tijdelijke plek zodat de shell ergens naartoe kan sturen.',
  },
  manageStub: {
    title: 'Beheer',
    lead: 'Kies een sectie in het menu.',
  },
};
